<div class="contact-page-container">
  
  <!-- Hero Search Header -->
  <section class="contact-hero text-center py-5">
    <div class="container">
      <span class="badge badge-pill bg-light text-primary mb-2 px-3 py-2 font-weight-bold">
        <i class="fas fa-headset mr-1"></i> ATENCIÓN MULTICANAL COLOMBIA
      </span>
      <h1 class="hero-title">¿En qué podemos ayudarte hoy?</h1>
      <p class="hero-subtitle text-muted">Resuelve tus inquietudes al instante o conecta con nuestro equipo de soporte con cobertura nacional.</p>
      
      <div class="search-box-wrapper mx-auto mt-4">
        <div class="input-group input-group-lg">
          <input type="text" class="form-control" placeholder="Escribe tu consulta (ej. 'Rastreo de guía', 'Garantía 30 días', 'Pago Nequi')..." [(ngModel)]="searchQuery">
          <button class="btn btn-primary px-4" type="button">
            <i class="fas fa-search mr-1"></i> Buscar
          </button>
        </div>
      </div>
    </div>
  </section>

  <div class="container py-4">
    <!-- Direct Channels Grid -->
    <div class="row mb-5">
      <div class="col-md-4 mb-3">
        <div class="contact-card card-whatsapp p-4">
          <div class="card-icon text-success mb-3">
            <i class="fab fa-whatsapp fa-3x"></i>
          </div>
          <span class="badge bg-success text-white mb-2">En línea &bull; &lt;5 min</span>
          <h4 class="card-title font-weight-bold">Línea WhatsApp Oficial</h4>
          <p class="text-muted small mb-3">Asistencia inmediata para confirmación de pedidos Contra Entrega, soporte en tiempo real y guías.</p>
          <a href="https://wa.me/573154567890" target="_blank" class="btn btn-success btn-block font-weight-bold">
            <i class="fab fa-whatsapp mr-2"></i> Chatear por WhatsApp
          </a>
        </div>
      </div>

      <div class="col-md-4 mb-3">
        <div class="contact-card card-callcenter p-4">
          <div class="card-icon text-primary mb-3">
            <i class="fas fa-phone-alt fa-3x"></i>
          </div>
          <span class="badge bg-primary text-white mb-2">Línea Gratuita</span>
          <h4 class="card-title font-weight-bold">Línea Telefónica Directa</h4>
          <p class="text-muted small mb-3">Atención personalizada de llamadas enrutadas desde cualquier operador celular o fijo de Colombia.</p>
          <div class="phone-numbers text-center mb-3">
            <div class="font-weight-bold">01 8000 910 224</div>
            <small class="text-muted">PBX Bogotá D.C.: (601) 745 6000</small>
          </div>
          <a href="tel:018000910224" class="btn btn-outline-primary btn-block font-weight-bold">
            <i class="fas fa-phone-volume mr-2"></i> Llamar Ahora
          </a>
        </div>
      </div>

      <div class="col-md-4 mb-3">
        <div class="contact-card card-pqrs p-4">
          <div class="card-icon text-warning mb-3">
            <i class="fas fa-gavel fa-3x"></i>
          </div>
          <span class="badge bg-warning text-dark mb-2">SIC Ley 1480</span>
          <h4 class="card-title font-weight-bold">Radicación PQRS y Reclamos</h4>
          <p class="text-muted small mb-3">Sistema formal de peticiones, quejas, recursos y garantías con generación de consecutivo legal expedito.</p>
          <a href="#form-pqrs-section" class="btn btn-primary btn-block font-weight-bold">
            <i class="fas fa-file-signature mr-2"></i> Radicar Solicitud Oficial
          </a>
        </div>
      </div>
    </div>

    <!-- Main Content: Form & FAQ -->
    <div class="row" id="form-pqrs-section">
      
      <!-- Form Column -->
      <div class="col-lg-7 mb-4">
        <div class="pqrs-form-card p-4">
          <div class="form-header d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 class="font-weight-bold mb-1">Envíanos un Mensaje o Radica tu Solicitud</h3>
              <p class="text-muted small mb-0">Completa el formulario para asignarte un agente de soporte.</p>
            </div>
            <span class="badge bg-light text-success border border-success p-2">
              <i class="fas fa-shield-alt mr-1"></i> Conexión Cifrada SSL
            </span>
          </div>

          <div *ngIf="isLoggedIn" class="user-autofill-banner alert alert-info mb-4">
            <i class="fas fa-user-check mr-2"></i>
            <span>Hola <strong>{{ user?.name }}</strong>, hemos autocompletado tus datos de contacto registrados.</span>
          </div>

          <form (ngSubmit)="submitPqrs()">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label font-weight-bold">Nombre Completo *</label>
                <input type="text" class="form-control" [(ngModel)]="pqrsData.fullName" name="fullName" required placeholder="Ej. Andrés Camilo Morales">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label font-weight-bold">Cédula de Ciudadanía / NIT</label>
                <input type="text" class="form-control" [(ngModel)]="pqrsData.documentId" name="documentId" placeholder="Ej. 1.018.452.990">
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label font-weight-bold">Correo Electrónico *</label>
                <input type="email" class="form-control" [(ngModel)]="pqrsData.email" name="email" required placeholder="andres@ejemplo.com">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label font-weight-bold">Teléfono Celular WhatsApp *</label>
                <input type="text" class="form-control" [(ngModel)]="pqrsData.phone" name="phone" required placeholder="+57 300 000 0000">
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label font-weight-bold">Motivo de Solicitud *</label>
                <select class="form-select form-control" [(ngModel)]="pqrsData.requestType" name="requestType">
                  <option value="Petición">Petición General</option>
                  <option value="Queja">Queja por Servicio</option>
                  <option value="Reclamo">Reclamo por Transportadora</option>
                  <option value="Garantía Ley 1480">Garantía o Cambio (Ley 1480)</option>
                  <option value="Devolución">Devolución de Dinero</option>
                </select>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label font-weight-bold">Número de Pedido (Opcional)</label>
                <input type="text" class="form-control" [(ngModel)]="pqrsData.orderNumber" name="orderNumber" placeholder="Ej. #AND-98241">
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label font-weight-bold">Descripción Detallada del Requerimiento *</label>
              <textarea class="form-control" rows="4" [(ngModel)]="pqrsData.description" name="description" required placeholder="Por favor describe de forma clara tu caso, número de guía si aplica, o novedades logísticas..."></textarea>
            </div>

            <button type="submit" class="btn btn-primary btn-block btn-lg font-weight-bold py-3 mt-4" [disabled]="loading">
              <i class="fas" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
              {{ loading ? ' Radicando...' : 'Enviar Mensaje / Radicar Ticket' }}
            </button>
          </form>
        </div>
      </div>

      <!-- FAQ & Delivery Times Column -->
      <div class="col-lg-5 mb-4">
        
        <!-- FAQ Accordion -->
        <div class="faq-card p-4 mb-4">
          <h4 class="font-weight-bold mb-3"><i class="far fa-question-circle text-primary mr-2"></i> Preguntas Frecuentes</h4>
          
          <div class="faq-accordion">
            <div class="faq-item mb-3" *ngFor="let faq of faqs; let i = index">
              <div class="faq-question d-flex justify-content-between align-items-center p-3" (click)="toggleFaq(i)">
                <span class="font-weight-bold text-dark">{{ faq.question }}</span>
                <i class="fas" [ngClass]="faq.open ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </div>
              <div class="faq-answer p-3 bg-light" *ngIf="faq.open">
                <p class="mb-0 text-muted small">{{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Delivery Times Card -->
        <div class="delivery-times-card p-4">
          <h5 class="font-weight-bold mb-3"><i class="fas fa-shipping-fast text-success mr-2"></i> Tiempos Promedio de Entrega</h5>
          <ul class="list-group list-group-flush small">
            <li class="list-group-item d-flex justify-content-between align-items-center px-0">
              <span>Bogotá D.C., Medellín y Cali (Express)</span>
              <strong class="text-primary">24 a 48 Horas</strong>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center px-0">
              <span>Costa Caribe y Eje Cafetero</span>
              <strong class="text-primary">48 a 72 Horas</strong>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center px-0">
              <span>Resto del País y Zonas Reexpedidas</span>
              <strong class="text-primary">3 a 5 Días</strong>
            </li>
          </ul>
        </div>

      </div>
    </div>

    <!-- Corporate Sede Location -->
    <div class="sede-location-card p-4 mt-4 bg-white rounded shadow-sm border">
      <div class="row align-items-center">
        <div class="col-md-7">
          <span class="badge bg-light text-primary font-weight-bold mb-2">SEDE PRINCIPAL CORPORATIVA</span>
          <h3 class="font-weight-bold mb-2">Visítanos en nuestra sede Bogotá</h3>
          <p class="text-muted small">Nuestras oficinas administrativas y de atención presencial para clientes mayoristas y radicaciones formales se encuentran en el corazón empresarial de la capital.</p>
          <ul class="list-unstyled text-muted small">
            <li class="mb-1"><i class="fas fa-building text-primary mr-2"></i> Torre Empresarial Chicó Norte - Piso 14</li>
            <li class="mb-1"><i class="fas fa-map-marker-alt text-primary mr-2"></i> Carrera 11 # 94-30, Apto 502, Bogotá D.C.</li>
            <li class="mb-1"><i class="fas fa-clock text-primary mr-2"></i> Lunes a Sábado: 7:00 AM - 9:00 PM</li>
          </ul>
        </div>
        <div class="col-md-5 text-center">
          <div class="map-placeholder-box p-4 rounded bg-light border text-center">
            <i class="fas fa-map-marked-alt text-primary fa-4x mb-3"></i>
            <h5 class="font-weight-bold">Bogotá D.C., Colombia</h5>
            <p class="small text-muted mb-3">Chicó Norte, Parqueadero de visitantes disponible</p>
            <a href="https://maps.google.com" target="_blank" class="btn btn-outline-primary btn-sm font-weight-bold">
              <i class="fas fa-directions mr-1"></i> Cómo llegar
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
